import React from 'react';
import { Alert, Col, Row } from 'antd';
import { Field } from 'redux-form';
import { SelectField, TextAreaField, TextField } from 'redux-form-antd';
import map from 'lodash/map';
import UploadDialog from '../UploadDialog';
import UploadDialogZIP from '../UploadDialogZip';
import FormValueSelector from '../../../containers/FormValueSelector';

// Ad Types.
export const creativeTypes = [
  { label: 'Custom URL', value: 'custom_url' },
  { label: 'Image Upload', value: 'image_upload' },
  { label: 'CMP Tag', value: 'cmp_tag' },
];

const inStoreMessage =
  "Survey's will only be shown to CheckPoints users, This inStore ad will not run on non-CheckPoints apps";
const inHandMessage =
  "Survey's will only be shown to CheckPoints users, This inHand product will not run on non-CheckPoints apps";

const CreativeTypeForm = ({
  activeCreative,
  namePrefix,
  formItemLayout,
  lineItemId,
  uploadPrefix,
  fieldOptions,
}) => (
  <Row type="flex">
    <Col style={{ flex: 1 }}>
      <Field
        {...formItemLayout}
        name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'name') : 'name'}
        label="Creative Name"
        component={TextField}
      />

      <FormValueSelector
        fieldName={namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_url') : 'creative_url'}
      >
        {creativeUrl => {
          const isInstore = !!lineItemId;
          let showWarn = false;
          if (
            creativeUrl &&
            typeof creativeUrl === 'string' &&
            creativeUrl.indexOf('surveygizmo') !== -1
          ) {
            showWarn = true;
          }

          return showWarn ? (
            <Alert
              style={{ marginBottom: 20 }}
              showIcon
              message={isInstore ? inStoreMessage : inHandMessage}
              type="warning"
            />
          ) : null;
        }}
      </FormValueSelector>

      <FormValueSelector
        fieldName={
          namePrefix ? namePrefix.replace('REPLACE_THIS', 'impression_pixels') : 'impression_pixels'
        }
      >
        {impressionPixels => {
          let showWarn = false;
          if (
            impressionPixels &&
            typeof impressionPixels === 'string' &&
            impressionPixels.indexOf('http:') !== -1
          ) {
            showWarn = true;
          }

          return showWarn ? (
            <Alert
              style={{ marginBottom: 20 }}
              showIcon
              closable
              message="One or more of your impression tags are using http instead of https, this may cause impression tracking issues on Android"
              type="warning"
            />
          ) : null;
        }}
      </FormValueSelector>

      <Field
        {...formItemLayout}
        name={namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_type') : 'creative_type'}
        label="Creative Type"
        component={SelectField}
        options={creativeTypes}
      />

      <FormValueSelector
        fieldName={
          namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_type') : 'creative_type'
        }
      >
        {adType => {
          if (!adType || adType === 'custom_url')
            return (
              <Field
                {...formItemLayout}
                label="Creative URL"
                name={
                  namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_url') : 'creative_url'
                }
                component={TextField}
              />
            );
          if (adType === 'cmp_tag')
            return (
              <Row>
                <Col>
                  <Field
                    {...formItemLayout}
                    label="CMP Tag"
                    name={
                      namePrefix
                        ? namePrefix.replace('REPLACE_THIS', 'creative_html')
                        : 'creative_html'
                    }
                    rows={8}
                    placeholder="HTML content goes here"
                    component={TextAreaField}
                  />
                </Col>
              </Row>
            );
          if (adType === 'image_upload')
            return (
              <Field
                {...formItemLayout}
                label="Click Through URL"
                name={
                  namePrefix
                    ? namePrefix.replace('REPLACE_THIS', 'click_through_url')
                    : 'click_through_url'
                }
                component={TextField}
              />
            );
          if (adType === 'html_upload')
            return [
              <Row key={1}>
                <Col offset={6}>
                  <Field
                    name={
                      namePrefix
                        ? namePrefix.replace('REPLACE_THIS', 'creative_html')
                        : 'creative_html'
                    }
                    action={
                      uploadPrefix
                        ? `${uploadPrefix}/zip`
                        : `${process.env.REACT_APP_INMARKET_API}/advertiser-ad/${lineItemId}/instore/upload/zip`
                    }
                    component={UploadDialogZIP}
                    type="input"
                  />
                </Col>
              </Row>,
              <Field
                key={2}
                {...formItemLayout}
                label="Click Through URL"
                name={
                  namePrefix
                    ? namePrefix.replace('REPLACE_THIS', 'click_through_url')
                    : 'click_through_url'
                }
                component={TextField}
              />,
            ];
        }}
      </FormValueSelector>

      <FormValueSelector
        fieldName={
          namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_type') : 'creative_type'
        }
      >
        {adType => {
          return fieldOptions.showImpressionPixels.indexOf(adType) !== -1 ? (
            <Field
              {...formItemLayout}
              rows={10}
              name={
                namePrefix
                  ? namePrefix.replace('REPLACE_THIS', 'impression_pixels')
                  : 'impression_pixels'
              }
              label="Impression Pixels"
              component={TextAreaField}
            />
          ) : null;
        }}
      </FormValueSelector>
    </Col>

    <FormValueSelector
      fieldName={namePrefix ? namePrefix.replace('REPLACE_THIS', 'creative_type') : 'creative_type'}
    >
      {adType => {
        if (adType === 'image_upload')
          return (
            <Col offset={1}>
              <Field
                name={
                  namePrefix
                    ? namePrefix.replace('REPLACE_THIS', 'creative_image')
                    : 'creative_image'
                }
                action={
                  uploadPrefix ||
                  `${process.env.REACT_APP_INMARKET_API}/advertiser-ad/${lineItemId}/instore/upload`
                }
                component={UploadDialog}
                type="input"
              />
            </Col>
          );
      }}
    </FormValueSelector>
  </Row>
);

CreativeTypeForm.defaultProps = {
  namePrefix: false,
  lineItemId: false,
  uploadPrefix: false,
  fieldOptions: {
    showImpressionPixels: map(creativeTypes, v => v.value !== 'custom_url' && v.value),
  },
  formItemLayout: {
    colon: false,
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  },
  columnOffset: 8,
};

export default CreativeTypeForm;
